import React, { useState } from 'react';
import { Box, Container, Tab, Tabs, Typography } from '@mui/material';
import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';
import { RootState } from '../../../store';
import { CatalogExplorer } from './catalog-explorer';
import { CascadeVisualizer } from './cascade-visualizer';
import { SystemDefaultsEditor } from './system-defaults-editor';
import { OverridesEditor } from './overrides-editor';

type TabKey = 'catalog' | 'cascade' | 'system' | 'overrides';

export const PomMasterSettingsScreen: React.FC = () => {
  const authUser = useSelector((s: RootState) => (s as any).auth?.authUser) as any;
  const [tab, setTab] = useState<TabKey>('catalog');

  if (!authUser?.pomMaster) {
    return <Navigate to="/" replace />;
  }

  return (
    <Container maxWidth="xl" sx={{ py: 3 }}>
      <Typography variant="h4" sx={{ mb: 1 }}>POM Master · Settings</Typography>
      <Typography variant="body2" sx={{ mb: 3, color: 'text.secondary' }}>
        Catalog explorer, cascade visualizer, and system-defaults editor for the v2 settings hierarchy.
      </Typography>
      <Tabs value={tab} onChange={(_, v) => setTab(v)} sx={{ mb: 3 }}>
        <Tab value="catalog"   label="Catalog explorer" />
        <Tab value="cascade"   label="Cascade visualizer" />
        <Tab value="system"    label="System defaults editor" />
        <Tab value="overrides" label="Overrides" />
      </Tabs>
      <Box>
        {tab === 'catalog'   && <CatalogExplorer />}
        {tab === 'cascade'   && <CascadeVisualizer />}
        {tab === 'system'    && <SystemDefaultsEditor />}
        {tab === 'overrides' && <OverridesEditor />}
      </Box>
    </Container>
  );
};

export default PomMasterSettingsScreen;
